<template>
  <div>
      <div class="box mb15">
            <el-page-header @back="$router.go(-1)"></el-page-header>
        </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div>
            <el-button type="warning" @click.native="$router.push(`/memberManagement/${$route.params.id}/comment`)">{{$t('tMemberComment')}}</el-button>
            <el-button type="warning" @click.native="$router.push(`/memberManagement/${$route.params.id}/discuss`)">{{$t('tMemberDiscuss')}}</el-button>
        </div>
        <div>
          <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
        </div>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:club_title="slotProps">
          <div>
            {{slotProps.callback.row.task.club.title}}
          </div>
        </template>
        <template v-slot:task_title="slotProps">
          <div>
            {{slotProps.callback.row.task.title}}
          </div>
        </template>
        <template v-slot:task_content="slotProps">
          <div>
            {{slotProps.callback.row.task.content}}
          </div>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { memberAttendanceList } from "@/api/api";
export default {
  name: "memberAttendance",
  mixins: [mixin_list(memberAttendanceList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        user_id: this.$route.params.id
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("memberAttendance.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("memberAttendance.title"),
          sortable: true,
          prop: "title",
        },
        {
          label: this.$t("memberAttendance.content"),
          sortable: true,
          prop: "content",
        },
        {
          label: this.$t("memberAttendance.file_name"),
          sortable: true,
          prop: "file_name",
        },
        {
          label: this.$t("memberAttendance.attach"),
          sortable: true,
          prop: "attach",
        },
        {
          label: this.$t("memberAttendance.club_title"),
          sortable: true,
          slot: "club_title",
          prop: "club.title",
        },
        {
          label: this.$t("memberAttendance.task_title"),
          sortable: true,
          prop: "task.title",
          slot:"task_title"
        },
        {
          label: this.$t("memberAttendance.task_content"),
          sortable: true,
          prop: "task.content",
          slot:"task_content"
        },
      ],
    };
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
/deep/ label{
  margin-bottom:0!important
}
</style>